import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MasterLayoutServiceService {
  private data='';
  constructor() { }


  setOption(value: any) {
    this.data = value;
  }

  getOption() {
    return this.data;
  }
}
